export default __webpack_public_path__ + "img/communityApplications.3ce44f1b.svg";